
// this page is what is holding all of the projects, here we are going to have to import all of my projects. 

export const projects = [
  {
    title: "Spring Boot Application",
    subtitle: "Deployment to Azure and Heroku",
    description:
      "During this project I developed a CRUD Spring Boot Application and deployed it to various hybrid cloud platforms such as Heroku, AWS, Azure and Google Cloud.",
    image: "./activity-3.gif",
    link: "https://github.com/cadensilvey/CST-323-Milestone",
  },
  {
    title: "Senior Year Capstone",
    subtitle: "Callaway Scoring System",
    description:
      "In this Capstone project, I utilized Python along with Flet which is a child of Flutter to create a ios application for users to calculate their Callaway Adjusted Score. All documentation is found in the padlet linked to this.",
    image: "./cally.gif",
    link: "https://padlet.com/silveys93/capstone-showcase-callaway-scoring-project-lhjebuer90cvmhkf",
  },
  {
    title: "API Demo",
    subtitle: "Created an API utilized .NET",
    description:
      "Utilized an external API to perform GET actions. ",
    image: "./bible-verse.gif",
    link: "https://github.com/cadensilvey?tab=repositories",
  },
  {
    title: "Minesweeper",
    subtitle: ".Net Core with API",
    description:
      "This is a minesweeper application built using C# and .Net. In this application users are able to login and create and save new games.",
    image: "./minesweeper.gif",
    link: "https://github.com/cadensilvey/Milestone-CST-350",
  },
  {
    title: "Weather App",
    subtitle: "React Core with API",
    description:
      "In this Weather Application you are able to type the name of any city that you want to and you will see the current weather in that city. An external API is leveraged with this applicaion.",
    image: "./weather.gif",
    link: "https://github.com/cadensilvey/weather-app",
  },
  {
    title: "Binary Search Tree Visualized",
    subtitle: "Data Structures and Algorithms",
    description:
      "React Application that demonstrates a Binary Search Tree with In-Order Traversal, Pre-Order Traversal, Post-Order Traversal, Depth-First Traversal, and Breadth-First Traversal",
    image: "./binary.gif",
    link: "https://github.com/cadensilvey/Binary_Tree_React_Example",
  },
];

export const testimonials = [
  {
    quote: "Connect with me on LinkedIn to see my professional profile and connect with me.",
    image: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/LinkedIn_icon_circle.svg/2048px-LinkedIn_icon_circle.svg.png",
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/cadensilvey395/"
  },
  {
    quote: "View my GitHub profile to see all of my repositories. All of my work from my schooling can be found here.",
    image: "https://e1.pngegg.com/pngimages/452/590/png-clipart-clay-os-6-a-macos-icon-github-desktop-white-cat-on-purple-background-icon-thumbnail.png",
    name: "GitHub",
    link: "https://github.com/cadensilvey?tab=repositories"
  },
];

export const skills = [
  "Java",
  "Python",
  "SQL",
  "MongoDB",
  "Dev Ops",
  "React",
  "Spring Boot",
  "C#",
  "OOP",
  "Full Stack",
];



// WEBPACK FOOTER //
// ./src/data.js